import { render, staticRenderFns } from "./MessageListMessageModern.vue?vue&type=template&id=b1f89266&scoped=true&functional=true"
import script from "./MessageListMessageModern.vue?vue&type=script&lang=js"
export * from "./MessageListMessageModern.vue?vue&type=script&lang=js"
import style0 from "./MessageListMessageModern.vue?vue&type=style&index=0&id=b1f89266&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "b1f89266",
  null
  
)

export default component.exports